import React from 'react'
import { AiFillStar, AiOutlineStar } from 'react-icons/ai'

// Read-only star strip. Supports decimal / half ratings via clip-path overlay.
//
// Props:
//   value: number (0–5; values outside this range are clamped)
//   size:  px (default 14)
//   showValue: boolean — show "(4.8)" after the stars
//   count: optional number — show "(N rəy)" after the stars
//   ariaLabel: optional override
//
// Accessibility: renders a single role="img" with a localized aria-label.

const StarDisplay = ({
    value = 0,
    size = 14,
    showValue = false,
    count,
    className = '',
    ariaLabel,
}) => {
    const v = Math.max(0, Math.min(5, Number(value) || 0))
    const fullPct = (v / 5) * 100

    const label = ariaLabel || (v > 0
        ? `${v.toFixed(1)} / 5 ulduz${typeof count === 'number' ? `, ${count} rəy` : ''}`
        : 'Reytinq yoxdur')

    return (
        <span
            role='img'
            aria-label={label}
            className={`inline-flex items-center gap-1 ${className}`}
        >
            <span className='relative inline-flex'>
                <span className='inline-flex gap-0.5 text-slate-300'>
                    {[0, 1, 2, 3, 4].map(i => (
                        <AiOutlineStar key={i} size={size} aria-hidden='true' />
                    ))}
                </span>
                <span
                    className='absolute inset-0 inline-flex gap-0.5 overflow-hidden text-warning-500 pointer-events-none'
                    style={{ width: `${fullPct}%` }}
                    aria-hidden='true'
                >
                    {[0, 1, 2, 3, 4].map(i => (
                        <AiFillStar key={i} size={size} />
                    ))}
                </span>
            </span>

            {(showValue || typeof count === 'number') && (
                <span className='text-xs text-slate-500'>
                    {showValue && v > 0 && (
                        <span className='font-semibold text-slate-700 mr-1'>{v.toFixed(1)}</span>
                    )}
                    {typeof count === 'number' && (
                        <span>({count} rəy)</span>
                    )}
                </span>
            )}
        </span>
    )
}

export default StarDisplay
